import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useMemo } from 'react';
import { useRealmApp } from '../RealmApp';

const useOrderItems = (order) => {
  const app = useRealmApp();
  const { orderItems, loading } = useAllOrderItems(
    app.currentUser.id,
    order.storeId,
    order._id
  );
  const result = useMemo(() => {
    const resultArray = [];
    order.items.forEach((orderItemId) => {
      const orderItem = orderItems.find((orderItem) => orderItem._id === orderItemId);
      if (orderItem) resultArray.push(orderItem);
    });
    return resultArray;
  }, [order, orderItems]);
  return {
    loading,
    orderItems: result,
  };
};

export default useOrderItems;

function useAllOrderItems(ownerId, storeId, orderId) {
  //
  const { data, loading, error } = useQuery(
    gql`
      query getOrderItems($ownerId: String!, $orderId: ObjectId!) {
        orderItems(query: { owner_id: $ownerId, orderId: $orderId }) {
          _id
          barcode
          baseUnitPrice
          commissionId
          commissionName
          courseId
          creationDatetime
          discountItemId
          discountPercent
          invoiceSerial
          itemId
          itemName
          measure {
            label
            owner_id
            unitPrice
            value
          }
          measureLabel
          measuredValue
          modifiers {
            _id
            name
            owner_id
            price
            quantity
          }
          net
          notes
          orderId
          orderType
          owner_id
          parentItemId
          quantity
          refundedQuantity
          status
          statusDatetime
          stockMasterId
          storeId
          subcategoryId
          subcategoryName
          tax1
          tax1Id
          tax1Imp
          tax2
          tax2Id
          tax2Imp
          tax3
          tax3Id
          tax3Imp
          tax4
          tax4Id
          tax4Imp
          terminalId
          total
          type
          unitPrice
          unlisted
          updateDatetime
          userId
          variant
        }
      }
    `,
    {
      variables: {
        ownerId: `owner_id=${ownerId}&store_id=${storeId}`,
        orderId,
      },
    }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const orderItems = data?.orderItems ?? [];
  return { orderItems, loading };
}
